<template>
  <view-container>
    <div class="mx-1" v-if="showClientFilter">
      <list-header>
        <reference-field
          label="Выберите клиента"
          reference="client"
          v-model="clientId"
        />
      </list-header>
    </div>
    <keep-alive>
      <router-view :clientId="clientId" />
    </keep-alive>
  </view-container>
</template>
<script>
export default {
  name: "ItemView",
  data() {
    return {
      clientId: null
    };
  },
  computed: {
    user() {
      return this.$store.getters["auth/getUser"];
    },
    showClientFilter() {
      return !this.user.clientId;
    }
  }
};
</script>
